

const WhatWeDoSummary = () => {
  return (
    <section className="section-container">
      <div className="text-center mb-12">
        <h2 className="section-title">We Don't Sell Trips. We Design Experiences.</h2>
        <p className="section-subtitle">
          MGL Experiences Ltd creates scalable travel intellectual property delivered through licensed regional partners.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        <div className="card">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-3">Experience Ownership</h3>
          <p className="text-gray-600">
            MGL Experiences Ltd owns the design, structure, and governance of every experience it creates. This ensures consistency, quality control, and long-term value across all markets.
          </p>
        </div>

        <div className="card">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-3">IP Model</h3>
          <p className="text-gray-600">
            Each experience is developed as a licensable intellectual property asset with defined standards, branding, and delivery frameworks. This allows experiences to scale while maintaining integrity.
          </p>
        </div>

        <div className="card">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-3">Partner Execution</h3>
          <p className="text-gray-600">
            Licensed regional travel operators execute all experiences, managing bookings, logistics, and on-ground delivery. This model enables compliance, local expertise, and operational efficiency.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoSummary;